import { useQuery } from 'react-query'
import { useAuthedFetch } from '../auth/useAuthedFetch'
import withFetchCancel from '../libs/withFetchCancel'

const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT

export const useManufacturedCountries = config => {
  const authedFetch = useAuthedFetch()

  const query = useQuery(
    'manufacturedCountries',
    () => {
      if (!config || config?.shouldExecuteQuery) {
        return withFetchCancel(signal =>
          authedFetch(
            'GET',
            `${BACKEND_ENDPOINT}/international-service/v1/manufactured-countries`,
            {
              parseJSON: true,
              signal,
            },
          ),
        );
      } else {
        return [];
      }
    },
    {
      select: ({ data }) => data,
      ...config,
    },
  )

  return query
}